import Http from "../../http/client";

export default async () => {
  const response = await Http.get('trip/matrix/enter');
  return response.data
}
